import { ClockIcon } from "@heroicons/react/outline";
import { CrudFilters } from "@refinedev/core";
import Button from "components/button";
import { HistoryLodModal } from "components/historyLogModal"
import { useState } from "react";
import { twMerge } from "tailwind-merge";

export const HistoryLogButton = ({
  resource,
  className,
  id,
  hideTitle = false,
  customFilters,
  showTitleOnMobile = false,
  lang
}: {
  resource: string,
  className?: string,
  id?: string,
  customFilters?: CrudFilters,
  hideTitle?: boolean,
  showTitleOnMobile?: boolean,
  lang?: string,
}) => {
  const [openLogModal, setOpenLogModal] = useState(false);
  
  return (
    <>
      <Button
        className={twMerge("bg-white border-brand-500 border-[1px] border-solid text-brand-500 hover:bg-white active:bg-slate-200 h-10 w-10 sm:w-auto", className)}
        onClick={() => setOpenLogModal(true)}
      >
        <span className="sr-only">History Log</span>
        <ClockIcon className="w-4 h-4 text-inherit" />{" "}
        {!hideTitle ? (
          <span className={showTitleOnMobile ? "block ml-2" : "hidden sm:block sm:ml-2"}>
            Log
          </span>
        ) : <></>}
      </Button>
      <HistoryLodModal
        resource={resource}
        open={openLogModal}
        onClose={() => setOpenLogModal(false)}
        key={id ?? resource}
        id={id ?? resource}
        customFilters={customFilters}
        lang={lang}
      />
    </>
  )
}
